import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Ideje",
  "description": "",
  "published": "2007-01-07T00:00:00.000Z",
  "redirect_from": ["/blog/ideje/swizec/334"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Nekje okoli poldneva danes sem imel odlicno idejo za blog, vendar se je uspela utopiti v morju matematike, ki je v doticnem trenutku polnilo mojo glavo. Na koncu sem se, tako kot ponavadi, boril z mozgani za idejo kaj naj pravzaprav pisem. V chatu je ravno takrat nekdo omenil palacinke in moj um je takoj veselo poskocil, saj palacinke so pa ja bloga vredna naprava.`}</p>
    <p>{`Raje pa sem se odlocil pisati o idejah samih. Kaj je pravzaprav ideja? Kaj je tisto, kar pripravi lastnika, da ob doloceni misli poskoci in rece `}<em parentName="p">{`Hej, to je pa ideja!`}</em>{` v vsem skupaj ni nobene logike. In zakaj so pravzaprav nekatere ideje dobre, nekatere pa slabe ... ceprav je to dokaj lahko vprasanje. Kar pa `}<strong parentName="p">{`ni`}</strong>{` lahko vprasanje je, od kje ideje sploh prihajajo?`}</p>
    <p>{`Veliko umetnikov verjame, da si lastijo tako imenovano Muzo, ki poskrbi za vedno svez dotok novih idej in zamisli. Ampak ali ima res kaj pri vsem skupaj? Ali sploh kdaj naredi kaj vec, kot sedi na svoji riti in te gleda, ko svicas za ideje? Odgovor je ne, sploh ne. Muza je samo dober izgovor na katerega lahko umetnik zvrne svoj uspeh, saj globoko v sebi se vsak boji uspeha, ker bi v koncni fazi to pomenilo totalno odgovornost za samega sebe, pomenilo bi, da ni usode, ni boga, ni nicesar razen nepomemnih nas.`}</p>
    <p>{`Zavedam se, da temu postu manjka pravi konec, ampak moja muza je sla na sekret.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      